module.exports = __webpack_public_path__ + "img/201908-1.423abb73.png";